import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  Modal,
  Select,
  Typography,
  // Upload,
  // message,
} from "antd";
// import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
// import { baseUrl } from "../../commonUtils/commonUtils";

const { Text } = Typography;

const RequiredLabel = ({ children }) => (
  <>
    {children}
    {" "}
    <Text style={{ color: "#FF0000" }}>{" "} *</Text>
  </>
);

const inputStyle = { height: 45 };

const AdminUserModal = ({
  open,
  isEditMode,
  initialValues,
  cityOptions,
  isCityLoading,
  isSubmitting,
  onCancel,
  onSubmit,
}) => {
  const [form] = Form.useForm();
  const [profileImageFile, setProfileImageFile] = useState(null);
  // const [imagePreviewUrl, setImagePreviewUrl] = useState(undefined);
  // const [isImageLoading, setIsImageLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setProfileImageFile(null);
    // setIsImageLoading(false);
    // setImagePreviewUrl(
    //   isEditMode && initialValues?.profile_image
    //     ? `${baseUrl}${initialValues.profile_image}`
    //     : undefined
    // );
    form.setFieldsValue(
      isEditMode
        ? {
            full_name: initialValues?.full_name,
            phone_number: initialValues?.phone_number,
            email: initialValues?.email,
            city: (initialValues?.city || []).map(
              (city) =>
                cityOptions.find(
                  (option) =>
                    option.value?.toLowerCase() === String(city).toLowerCase()
                )?.value || city
            ),
          }
        : {}
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, isEditMode, initialValues, cityOptions]);

  const handleCancel = () => {
    form.resetFields();
    setProfileImageFile(null);
    // setImagePreviewUrl(undefined);
    onCancel();
  };

  const handleFinish = (values) => {
    onSubmit(values, profileImageFile);
  };

  const numericKeyGuard = (e) => {
    if (
      (e.key < "0" || e.key > "9") &&
      e.key !== "Backspace" &&
      e.key !== "ArrowLeft" &&
      e.key !== "ArrowRight" &&
      e.key !== "Tab"
    ) {
      e.preventDefault();
    }
  };

  // const beforeImageUpload = (file) => {
  //   const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  //   if (!isJpgOrPng) {
  //     message.error("You can only upload JPG/PNG file!");
  //     return Upload.LIST_IGNORE;
  //   }
  //   const isLt2M = file.size / 1024 / 1024 < 2;
  //   if (!isLt2M) {
  //     message.error("Image must be smaller than 2MB!");
  //     return Upload.LIST_IGNORE;
  //   }
  //   setIsImageLoading(true);
  //   setProfileImageFile(file);
  //   // setImagePreviewUrl(URL.createObjectURL(file));
  //   setIsImageLoading(false);
  //   return false;
  // };

  // const uploadButton = (
  //   <button style={{ border: 0, background: "none" }} type="button">
  //     {isImageLoading ? <LoadingOutlined /> : <PlusOutlined />}
  //     <div style={{ marginTop: 8 }}>Upload</div>
  //   </button>
  // );

  return (
    <Modal
      title={isEditMode ? "Edit admin user" : "Add admin user"}
      open={open}
      onCancel={handleCancel}
      onOk={() => form.submit()}
      footer={[
        <Col
          key="footer"
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "28px",
          }}
        >
          <Button
            key="cancel"
            onClick={handleCancel}
            style={{
              height: "48px",
              fontWeight: 500,
              fontSize: "14px",
              width: "120px",
            }}
          >
            CANCEL
          </Button>
          <Button
            key="save"
            type="primary"
            loading={isSubmitting}
            onClick={() => form.submit()}
            style={{
              height: "48px",
              fontWeight: 500,
              fontSize: "14px",
              width: "200px",
              backgroundColor: "#0354a3",
            }}
          >
            {isEditMode ? "SAVE CHANGES" : "ADD ADMIN"}
          </Button>
        </Col>,
      ]}
    >
      <Col style={{ padding: "0.5rem 2rem", minHeight: "400px" }}>
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          requiredMark={false}
          onFinish={handleFinish}
        >
          {!isEditMode && (
            <>
              <Form.Item
                label={<RequiredLabel>Username (Email ID)</RequiredLabel>}
                name="username"
                rules={[
                  { required: true, message: "Please enter a username" },
                  { type: "email", message: "Please enter a valid email ID" },
                ]}
              >
                <Input style={inputStyle} autoComplete="new-password" />
              </Form.Item>
              <Form.Item
                label={<RequiredLabel>Password</RequiredLabel>}
                name="password"
                rules={[
                  { required: true, message: "Please enter a password" },
                  { min: 8, message: "Password must be at least 8 characters" },
                  { max: 20, message: "Password must not exceed 20 characters" },
                ]}
              >
                <Input.Password
                  style={inputStyle}
                  maxLength={20}
                  autoComplete="new-password"
                />
              </Form.Item>
            </>
          )}
          <Form.Item
            label={<RequiredLabel>Full name</RequiredLabel>}
            name="full_name"
            rules={[{ required: true, message: "Please enter the full name" }]}
          >
            <Input style={inputStyle} />
          </Form.Item>
          <Form.Item
            label={<RequiredLabel>Phone number</RequiredLabel>}
            name="phone_number"
            rules={[
              { required: true, message: "Please enter the phone number" },
            ]}
          >
            <Input style={inputStyle} maxLength={10} onKeyDown={numericKeyGuard} />
          </Form.Item>
          {/* {isEditMode && (
            <Form.Item label="Email" name="email">
              <Input style={inputStyle} />
            </Form.Item>
          )} */}
          {/* <Form.Item label="Profile image">
            <Upload
              name="profile_image"
              listType="picture-card"
              showUploadList={false}
              accept=".png,.jpeg,.jpg,image/png,image/jpeg,image/jpg"
              beforeUpload={beforeImageUpload}
            >
              {imagePreviewUrl ? (
                <img
                  src={imagePreviewUrl}
                  alt="profile"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              ) : (
                uploadButton
              )}
            </Upload>
          </Form.Item> */}
          <Form.Item
            label={<RequiredLabel>City Access</RequiredLabel>}
            name="city"
            rules={[
              { required: true, message: "Please select at least one city" },
            ]}
          >
            <Select
              mode="multiple"
              placeholder="Select city"
              loading={isCityLoading}
              options={cityOptions}
              showSearch
              optionFilterProp="label"
              maxTagCount="responsive"
              style={{ minHeight: 45 }}
              dropdownRender={(menu) => {
                const allCityValues = cityOptions.map((option) => option.value);
                const selectedCities = form.getFieldValue("city") || [];
                const allSelected =
                  allCityValues.length > 0 &&
                  selectedCities.length === allCityValues.length;
                const someSelected =
                  selectedCities.length > 0 && !allSelected;

                const toggleSelectAll = () => {
                  form.setFieldValue("city", allSelected ? [] : allCityValues);
                  form.validateFields(["city"]);
                };

                return (
                  <>
                    <Col
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={
                        allCityValues.length ? toggleSelectAll : undefined
                      }
                      style={{
                        padding: "8px 12px",
                        cursor: allCityValues.length ? "pointer" : "default",
                      }}
                    >
                      <Checkbox
                        checked={allSelected}
                        indeterminate={someSelected}
                        disabled={!allCityValues.length}
                      >
                        {allSelected ? "Deselect all" : "Select all"}
                      </Checkbox>
                    </Col>
                    <Divider style={{ margin: "4px 0" }} />
                    {menu}
                  </>
                );
              }}
            />
          </Form.Item>
        </Form>
      </Col>
    </Modal>
  );
};

export default AdminUserModal;
